
<!--
* A claim type list item
*
* todo
-->

<template>
  <!-- list item to display an option for claim type -->
  <li class="claim-type__item"
      :claimType="claimType"
      v-on:click="onClick()"
      v-bind:class="{ 'claim-type__item--state-active': isActive }">
    <!-- icon class -->
    <img :src="'/static/theme/img/' + claimType.src" class="claim-type__icon">
    <!-- title -->
    <span class="claim-type__title" v-text="claimType.title"></span>
    <!-- select button -->
    <img src="@/assets/theme/images/dark-select-arrow.png" class="claim-type__select">
  </li>
</template>

<script>
  export default {
    props: [ 'claimType', 'isActive' ],
    methods: {
      onClick () {
        this.$emit('selected', this.claimType)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/sass/shared.scss";

  $icon-width: 50px;
  $icon-height: 50px;
  $select-width: 10px;
  $item-background: $quaternary-brand-color;
  $item-active-background: darken($item-background, 10%);

  .claim-type__item {
    font-family: $base-font-stack;
    font-weight: $semibold-font-weight;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: $dims-padding-default $dims-horizontal-gutter;
    background-color: $item-background;

    &:hover {
      background-color: $item-active-background;
    }
  }

  .claim-type__item--state-active {
    background-color: $item-active-background;
  }

  .claim-type__icon {
    width: $icon-width;
    height: $icon-height;
  }

  .claim-type__title {
    flex: 1;
    padding: 0 $dims-padding-default;
  }

  .claim-type__select {
    width: $select-width;
    height: auto;
  }

</style>
